import { useEffect, useState } from 'react';
import './GamePortfolio.scss';
import ActionItems from '../ActionItems/ActionItems';
import { GameRenderer } from './Game/GameRenderer';
import Portfolio from "../../core/enums/Portfolio";
import { IProps } from "../../App";

const GamePortfolio = (props: IProps) => {
  let mount: HTMLElement;
  const [gameRenderer] = useState(new GameRenderer());

  useEffect(() => {
    gameRenderer.initializeGame(mount);

    return (): void => {
      gameRenderer.gui?.destroy();
      gameRenderer.audio.stop();

      gameRenderer.unsubscribeNotifier$.next();
      gameRenderer.unsubscribeNotifier$.complete();
    }
  });

  return (
    <div className="game-portfolio">
      <div ref={ref => (mount = ref as HTMLElement)} />
      <ActionItems
        changeLocation={props.changeLocation}
        location={Portfolio.Game}
      ></ActionItems>
    </div>
  );
}

export default GamePortfolio;